import { all } from 'redux-saga/effects';
import authSagas from './Auth';
import ring from './Ring'
import sitNgo from './SitnGo';
import Tournament from './Tournament';
import Leaderboard from './Leaderboard';
import Achievement from './Achievement';
import Template from './Template';
import WithdrawSwap from './WithdrawSwap';
import GameStore from './GameStore';
import PendingWithdrawals from './PendingWithdrawals';
import Users from './Users';
import Dashboard from './Dashboard';
import Settings from './Settings';

export default function* rootSaga() {
  yield all([
    authSagas(),
    ring(),
    sitNgo(),
    Template(),
    Tournament(),
    Leaderboard(),
    Achievement(),
    WithdrawSwap(),
    GameStore(),
    PendingWithdrawals(),
    Users(),
    Dashboard(),
    Settings()
  ]);
}

